@if (isLoading) {
<div class="panel-title-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
}
@else {
<h2 class="panel-title">{{('Modules.XPACManagementComponent.XpacLoggingComponent.TitleLogging' | translate)}}</h2>

<div *ngIf="deviceLogging.length">
  <div class="padding-list">
    <ng-container *ngFor="let log of deviceLogging">
      <app-list-item title="{{ log.message }}" [info]="getInfoString(log)" showActionIcon="true"
        (click)="onLogClick(log)" [showItemStatus]="false">
      </app-list-item>
    </ng-container>

    <div class="action-buttons" *ngIf="hasMore">
      <ng-container *ngIf="isLoadingMore; then loading else loadAction"></ng-container>

      <ng-template #loadAction>
        <button mat-flat-button class="button small-button" (click)="loadMore()">
          <mat-icon>update</mat-icon>
          <p>{{ 'General.LoadMore' | translate }}</p>
        </button>
      </ng-template>

      <ng-template #loading>
        <mat-spinner class="spinner" diameter="28"></mat-spinner>
      </ng-template>
    </div>
  </div>
</div>
}